import { yupResolver } from '@hookform/resolvers/yup';
import { CustomButton, CustomTextInput } from '@Modules/core/components';
import CustomFormControl from '@Modules/core/components/form/CustomFormControl';
import AppLoader from '@Modules/core/components/Loader';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import React from 'react';
import { useForm } from 'react-hook-form';
import { IChangePasswordMeta } from '../../containers/forms/ChangePasswordHandle/ChangePasswordFormMeta';

type Props = {
  onSubmit: any,
  meta: IChangePasswordMeta,
  isLoading: boolean,
  isSubmitting: boolean,
};

export default React.forwardRef(function ChangePasswordUI(
  { onSubmit, meta, isLoading, isSubmitting }: Props,
  ref
) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({ resolver: yupResolver(meta.schema) });

  React.useImperativeHandle(ref, () => ({
    reset,
  }));

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
          <CC.Box bg='chakra-body-bg' boxShadow="sm" borderRadius="lg" flex="1" w="full">
            <CC.Stack spacing="5" px={{ base: '4', md: '6' }} py={{ base: '5', md: '6' }} w="full" mb="4">
              <CC.Stack spacing="6" direction={{ base: 'column', md: 'row' }}>
                <CC.FormControl mr="2">
                  <CustomFormControl isInvalid={!!errors[meta.login.name]} label={meta.login.label}>
                    <CustomTextInput
                      meta={meta.login}
                      register={register(meta.login.name)}
                      hasError={errors[meta.login.name]}
                    />
                  </CustomFormControl>
                </CC.FormControl>

                <CC.FormControl mr="2">
                  <CustomFormControl isInvalid={!!errors[meta.oldPassword.name]} label={meta.oldPassword.label}>
                    <CustomTextInput
                      meta={meta.oldPassword}
                      register={register(meta.oldPassword.name)}
                      hasError={errors[meta.oldPassword.name]}
                    />
                  </CustomFormControl>
                </CC.FormControl>
              </CC.Stack>
              <CC.Stack spacing="6" direction={{ base: 'column', md: 'row' }}>
                <CC.FormControl>
                  <CustomFormControl isInvalid={!!errors[meta.newPassword.name]} label={meta.newPassword.label}>
                    <CustomTextInput
                      meta={meta.newPassword}
                      register={register(meta.newPassword.name)}
                      hasError={errors[meta.newPassword.name]}
                    />
                  </CustomFormControl>
                </CC.FormControl>

                <CC.FormControl>
                  <CustomFormControl isInvalid={!!errors[meta.typePasswordAgain.name]} label={meta.typePasswordAgain.label}>
                    <CustomTextInput
                      meta={meta.typePasswordAgain}
                      register={register(meta.typePasswordAgain.name)}
                      hasError={errors[meta.typePasswordAgain.name]}
                    />
                  </CustomFormControl>
                </CC.FormControl>
              </CC.Stack>
            </CC.Stack>
          <CC.Divider />
          <CC.Flex justify={'end'} direction="row-reverse" py="4" px={{ base: '4', md: '6' }}>
            <CustomButton loading={isSubmitting} type="submit" colorScheme="blue">
              Sauvegarder
            </CustomButton>
          </CC.Flex>
        </CC.Box>
      </form>
    </>
  );
});
